import React from "react";
import LZString from "lz-string";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";

import App from "./shared/App";
import packageJSON from "../package.json";
// import "lending-journey-ui-styles";
import "./assets/styles/index.css";

// Cleanup old service workers from vite-pwa
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().then(() => {
        console.log(
          "[SW Cleanup] Unregistered service worker:",
          registration.scope
        );
      });
    });
  });

  // Also clear all caches from the main thread as a fallback
  if ("caches" in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName).then(() => {
          console.log("[Cache Cleanup] Deleted cache:", cacheName);
        });
      });
    });
  }
}

window.lzstring = LZString;
function NoStorageEnabled() {
  return (
    <div className="mx-4 py-10 leading-8">
      <p className="text-center text-sm">
        Please enable Device Storage Access to continue using <br />
        <span className="font-semibold">FinBox Platform Dashboard</span>
      </p>
    </div>
  );
}

const canRenderApp = !!window.localStorage;

if (import.meta.env.REACT_APP_ENV === "PROD") {
  Sentry.init({
    dsn: "https://f20cfe93bf1a44e1893cb52469b6fdb4@o82232.ingest.sentry.io/6366422",
    environment: import.meta.env.REACT_APP_ENV,
    release: packageJSON.name + "@" + packageJSON.version,
    ignoreErrors: [
      "Non-Error promise rejection captured",
      "error loading dynamically imported module"
    ],
    beforeSend: (event) => {
        return event;
    },
    integrations: [
      new Sentry.Integrations.Breadcrumbs({
        console: import.meta.env.REACT_APP_ENV === "PROD"
      })
    ]
  });
}

if (canRenderApp) {
  ReactDOM.createRoot(document.getElementById("root")).render(<App />);
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <NoStorageEnabled />
  );
}

const DOMAIN_SUPPORT = [
  "finbox-platform-dashboard-uat-10.s3-website.ap-south-1.amazonaws.com",
  "adityabirla-bl-platform.fbxcloud.in",
  "adityabirla-platform.finbox.in",
  "finbox-platform-dashboard-uat-19.s3-website.ap-south-1.amazonaws.com",
  "herofincorp-platform.fbxcloud.in",
  "herofincorp-platform.finbox.in"
];

if (DOMAIN_SUPPORT?.includes(window?.location?.host)) {
  const favicons = document.querySelectorAll('link[rel="icon"]');
  favicons.forEach((link) => {
    document.head.removeChild(link);
  });
  let link = document.createElement("link");
  link.id = "dynamic-favicon";
  link.rel = "icon";

  switch(window?.location?.host) {
    case "adityabirla-platform.finbox.in":
    case "finbox-platform-dashboard-uat-10.s3-website.ap-south-1.amazonaws.com":
    case "adityabirla-bl-platform.fbxcloud.in":
      document.title = "Aditya Birla Capital";
      link.href = "/abfl-fav.png";
      break;
    case "herofincorp-platform.finbox.in":
    case "finbox-platform-dashboard-uat-19.s3-website.ap-south-1.amazonaws.com":
    case "herofincorp-platform.fbxcloud.in":
      document.title = "HeroFincorp Platform Dashboard";
      link.href = "/hfcl-fav.png";
      break;
    default:
      document.title = "FinBox Platform Dashboard";
      link.href = "/finbox_192x192.png";
  }
  
  document.head.appendChild(link);
}
